import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PERMISSION_SUB_MODULES } from '@/shared/const'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PermissionGuard } from '@/shared/ui/permission-guard'
import { ManualAttendanceAndFoodReceiptsWidget } from '@/widgets/manual-attendance-and-food-receipts-widget'

export const Route = createFileRoute('/_auth/canteen/manual-attendance-and-food-receipt/list')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PermissionGuard permission={PERMISSION_SUB_MODULES.MANUAL_ATTENDANCE}>
      <PageWrapper title={t('Ручной учет посещения и получения питания')}>
        <ManualAttendanceAndFoodReceiptsWidget />
        <Outlet />
      </PageWrapper>
    </PermissionGuard>
  )
}
